// LocalStorage helper.
export const localStore = {
    keys: {
        organizationKey: "orgstore"
    },
    // Set
    set: function (key: string, value: string) {
        localStorage.setItem(key, value);
    },
    setObject: function (key: string, value: any) {
        if (!!value) {
            localStorage.setItem(key, JSON.stringify(value));
        }
    },

    // Get
    get: function <T>(key: string) {
        return localStorage.getItem(key) as T;
    },
    getObject: function <T>(key: string) {
        var str = localStorage.getItem(key);
        if (!!str) {
            return JSON.parse(str) as T;
        } else {
            return undefined;
        }
    },

    // Delete
    remove: (key: string) => {
        localStorage.removeItem(key);
    },
    clearAll: () => {
        localStorage.clear();
    }
}